module.exports = __webpack_public_path__ + "static/residential1-7f9202955270ae32ac3c1d410070c4a8.jpg";